import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/App';
import { auth } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Cpu, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await auth.login({ email, password });
      login(res.data.token, res.data);
      navigate(res.data.is_admin ? '/admin' : '/dashboard');
      toast.success('Welcome back!');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login failed');
    }
    setLoading(false);
  };

  return (
    <div className="light-page min-h-screen bg-gradient-to-br from-slate-50 to-brand-bg-muted flex items-center justify-center p-4" style={{background: `linear-gradient(to bottom right, #f8fafc, color-mix(in srgb, var(--brand-primary) 4%, white))`}}>
      <Card data-testid="login-card" className="w-full max-w-md border-slate-200 bg-white shadow-xl shadow-slate-200/50">
        <CardHeader className="text-center space-y-3">
          <img src="/tensornex-logo.png" alt="Tensornex" className="mx-auto w-14 h-14 object-contain" />
          <CardTitle className="text-2xl text-slate-900" style={{fontFamily: "'Plus Jakarta Sans', sans-serif"}}>Welcome back</CardTitle>
          <CardDescription>Sign in to your Tensornex account</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input data-testid="login-email" id="email" type="email" placeholder="you@company.com" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input data-testid="login-password" id="password" type="password" placeholder="Enter your password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <Button data-testid="login-submit" type="submit" className="w-full brand-btn h-10 text-sm" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </form>
          <p className="text-center text-sm text-slate-500 mt-4">
            Don't have an account?{' '}
            <Link to="/signup" className="brand-link font-medium">Sign up</Link>
          </p>
          <p className="text-center text-sm text-slate-400 mt-2">
            <Link to="/reset-password" className="hover:underline">Forgot password?</Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
